import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

export const useCreatePermissions = () => {
  const { userInfo } = useInitialInfoStore();
  const { workbenchMode } = useInitialInfoStore();
  const hasCreate = userInfo.activation_creator_enabled;
  return (typeof hasCreate === 'boolean' ? hasCreate : true) || workbenchMode;
};
